import { updates } from "@/mocks/comics";

export default function Updates() {
  return (
    <section id="update" className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col items-start justify-between gap-3 md:flex-row md:items-end">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-3 py-1 text-sm font-medium text-secondary-900">
              <i className="ri-refresh-line text-primary-600"></i>
              最新更新
            </span>
            <h2 className="font-heading mt-3 text-2xl font-bold text-foreground-950 md:text-4xl">
              新章节实时同步，追更不迷路
            </h2>
            <p className="mt-2 max-w-xl text-sm text-foreground-600 md:text-base">
              持续追踪每部作品的更新进度，最新章节第一时间送达，热门连载每周稳定追更。
            </p>
          </div>
          <div className="flex items-center gap-2 rounded-full bg-background-50 px-4 py-2 text-sm text-foreground-600">
            <span className="relative flex h-2 w-2">
              <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-primary-500 opacity-75"></span>
              <span className="relative inline-flex h-2 w-2 rounded-full bg-primary-500"></span>
            </span>
            实时更新中
          </div>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-3 lg:grid-cols-2">
          {updates.map((u) => (
            <a
              key={u.title}
              href="#update"
              className="flex items-center gap-3 rounded-lg border border-background-200/70 bg-background-50 px-4 py-3.5 transition-colors hover:border-primary-200"
            >
              <span className="inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-primary-100 text-primary-600">
                <i className="ri-bookmark-line"></i>
              </span>
              <div className="min-w-0 flex-1">
                <div className="flex items-center gap-2">
                  <h3 className="truncate text-sm font-semibold text-foreground-950">{u.title}</h3>
                  <span className="shrink-0 rounded bg-secondary-100 px-1.5 py-0.5 text-xs text-secondary-900">
                    {u.tag}
                  </span>
                </div>
                <p className="mt-0.5 truncate text-sm text-primary-600">{u.chapter}</p>
              </div>
              <span className="shrink-0 text-xs text-foreground-500">{u.time}</span>
              <span className="hidden shrink-0 rounded-full bg-accent-100 px-2.5 py-1 text-xs font-medium text-accent-900 sm:inline-block">
                {u.type}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}